// extracted by mini-css-extract-plugin
module.exports = {"list":"about-us_list__oPTIC","item":"about-us_item__30KTc","itemShape":"about-us_itemShape__KV1c9"};